import React from 'react'
import { Button, Ref } from 'semantic-ui-react'
import Status from '../reducers/questions/status'
import { getQuestionStatus } from '../reducers/questions'
import { hotkeys, hotkey_display } from 'react-keyboard-shortcuts'
import TimedLabel from './TimedLabel.js'
import MidiController from './MidiController'

class QuizQuestionActions extends React.PureComponent {
    state ={betEnabled:false, askEnabled:false}

    hot_keys = {
        'alt+s': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleBetClick() }
        },
        'alt+d': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.handleAskClick() }
        },
        'alt+g': {
            priority: 1,
            handler: (e) => { e.preventDefault(); this.answersLink.click() }
        }
    }

    handleBetClick = () => {
        const { active, question, game_id, onBet, state } = this.props
        const status = getQuestionStatus(question.id, game_id, state )
        if (status !== Status.TO_BET)
            return
        if (!active)
            return
        this.setState({betEnabled:true})
        onBet(question)
    }

    handleAskClick = () => {
        const {active, question, game_id, onAsk, state } = this.props
        const status = getQuestionStatus(question.id, game_id, state )
        if (status !== Status.TO_ASK)
            return
        if (!active)
            return
        this.setState({askEnabled:true})
        onAsk(question)
    }

    handleSendAnswers = () => {
        const { question, onDownloadAnswers, game_id, state } = this.props
        const status = getQuestionStatus(question.id, game_id, state )
        if (status !== Status.ASKED)
            return

        onDownloadAnswers(question)
    }

    handleRef = (answersLink) => {
        this.answersLink = answersLink
    }

    render() {
        const {betEnabled,askEnabled} =this.state;
        const { question, game_id, index, active, onBet, onAsk, onDownloadAnswers, onDownloadChampions, state, ...otherProps } = this.props
        const status = getQuestionStatus(question.id, game_id, state)
        const betIsPrimary = [Status.TO_BET, Status.WAITING_BET_ASKED, Status.WAITING_BETS].indexOf(status) !== -1
        const askIsPrimary = [Status.TO_ASK, Status.WAITING_ASKED, Status.WAITING_ANSWERS].indexOf(status) !== -1
        const { userAnswersCount } = question
        const answersHref = //(window.location.hostname === 'localhost' ? 'http://localhost:3100' : '') +
            '/api/userAnswers/' + question.id +"/"+ game_id
    
        return (
            <div>
            <Button.Group {...otherProps}>
                {/* status === Status.ASKED  Modifica aggiunta altrimenti al termine della domanda, il tasto scommesse*/}
                {/* ritornava disabilitato e non più "cliccabile" per vedere le scommesse*/}
                {askIsPrimary || status === Status.ASKED ? 
                    <Button as='a' href={answersHref} download="Scommesse.csv">Vedi scommesse</Button> :
                    <Button primary={betIsPrimary} disabled={status !== Status.TO_BET} onClick={this.handleBetClick}>
                        Scommessa <TimedLabel enabled = {betEnabled}  type ={'bet'} /><br />
                        ({hotkey_display('alt+s')})
                    </Button>
                }
                
                {status === Status.ASKED ? 
                    <Ref innerRef={this.handleRef}>
                        <Button as='a' href={answersHref} download={'Risposte_' + (index + 1) + '.csv'} onClick={() => onDownloadAnswers(question)}>
                            Vedi e manda risposte ({userAnswersCount})<br />
                            ({hotkey_display('alt+g')})
                        </Button>
                    </Ref> : 
                    <Button primary={askIsPrimary} disabled={status !== Status.TO_ASK} onClick={this.handleAskClick}>
                        Domanda <TimedLabel enabled = {askEnabled} type ={'ask'} /><br />
                        ({hotkey_display('alt+d')})
                    </Button>}
            </Button.Group>
          <MidiController handleBetClick ={this.handleBetClick} handleAskClick={this.handleAskClick} handleSendAnswers={this.handleSendAnswers} handleDownloadChampions ={onDownloadChampions}/>
            </div>
        )
    }
}

export default hotkeys(QuizQuestionActions)


// WEBPACK FOOTER //
// ./src/components/QuizQuestionActions.js